import merge from '~lodash.mergewith'
import * as CoreSdk from '~@sentry/core'
import { captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } from '~@sentry/browser'
import { replayIntegration } from '~@sentry/browser'
import { extraErrorDataIntegration, reportingObserverIntegration } from '~@sentry/integrations'
import { init, browserTracingIntegration } from '~@sentry/vue'

export { init }
export const SentrySdk = { ...CoreSdk, ...{ captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } }

/** @type {string[]} */
const DISABLED_INTEGRATION_KEYS = []

/**
 * @typedef {Parameters<typeof init>[0]} InitConfig
 * @param {import('@nuxt/types').Context} ctx
 * @return {Promise<InitConfig>}
 */
export function getConfig (ctx) {
  /** @type {InitConfig} */
  const config = {
    dsn:"https:\u002F\u002F4d8ef28467be3050c998c828916d301a@sentry-strana.itstrana.site\u002F25",
    environment:"production",
    ignoreErrors:[new RegExp("^\\$ is not defined", ""),new RegExp("^\\$ is not a function", ""),new RegExp("^Can't find variable: \\$", ""),new RegExp("^ym is not defined", ""),new RegExp("^Can't find variable: ym", "")],
    replaysSessionSampleRate:1,
    replaysOnErrorSampleRate:1,
    tracesSampleRate:1,
  }

  /** @type {NonNullable<InitConfig>['integrations']} */
  const resolvedIntegrations = [
    extraErrorDataIntegration(),
    reportingObserverIntegration({ types:["crash"] }),
    replayIntegration(),
  ]

  resolvedIntegrations.push(browserTracingIntegration({
    router: ctx.app.router,
    ...{"routeLabel":"name"},
    ...{},
  }))
  merge(config, {"trackComponents":true}, {"tracesSampleRate":1,"ignoreUrls":[new RegExp("^https:\\\u002F\\\u002Fwww\\.googletagmanager\\.com\\\u002F", ""),new RegExp("^https:\\\u002F\\\u002Fwww\\.google\\.com\\\u002F", ""),new RegExp("^https:\\\u002F\\\u002Fwww\\.googletagmanager\\.com\\\u002F", ""),new RegExp("^https:\\\u002F\\\u002Fwww\\.yandex\\.com\\\u002F", "")]})

  config.integrations = (defaultIntegrations) => {
    return [
      ...defaultIntegrations.filter(integration => !DISABLED_INTEGRATION_KEYS.includes(integration.name)),
      ...resolvedIntegrations,
    ]
  }
  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
